
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { Page } from '@/types/page';

@Component
export default class PageMetaDataInput extends Vue {
  @Prop() page!: Page;

  @Mutation('pageEditor/setPageMetaTitle') setPageMetaTitle!: Function;
  @Mutation('pageEditor/setPageMetaDescription')
  setPageMetaDescription!: Function;
  @Mutation('pageEditor/setPageCanonicalUrl') setPageCanonicalUrl!: Function;
  @Mutation('pageEditor/setPageTwitterTitle') setPageTwitterTitle!: Function;
  @Mutation('pageEditor/setPageTwitterDescription')
  setPageTwitterDescription!: Function;
  @Mutation('pageEditor/setPageOpenGraphTitle')
  setPageOpenGraphTitle!: Function;
  @Mutation('pageEditor/setPageOpenGraphDescription')
  setPageOpenGraphDescription!: Function;

  get meta_title() {
    return this.page.meta!.meta_title;
  }
  set meta_title(value) {
    this.setPageMetaTitle(value);
  }
  get meta_description() {
    return this.page.meta!.meta_description;
  }
  set meta_description(value) {
    this.setPageMetaDescription(value);
  }
  get canonical_url() {
    return this.page.meta!.canonical_url;
  }
  set canonical_url(value) {
    this.setPageCanonicalUrl(value);
  }

  get twitter_title() {
    return this.page.meta!.twitter_title;
  }
  set twitter_title(value) {
    this.setPageTwitterTitle(value);
  }
  get twitter_description() {
    return this.page.meta!.twitter_description;
  }
  set twitter_description(value) {
    this.setPageTwitterDescription(value);
  }

  get open_graph_title() {
    return this.page.meta!.open_graph_title;
  }
  set open_graph_title(value) {
    this.setPageOpenGraphTitle(value);
  }
  get open_graph_description() {
    return this.page.meta!.open_graph_description;
  }
  set open_graph_description(value) {
    this.setPageOpenGraphDescription(value);
  }
}
